import { take, call, put } from 'redux-saga/effects';
import {
	sendForms,
	failSendForms,
	successSendForms,
} from '../actions';
import superFetch from '../modules/superFetch';
import {getApiUrl} from "./index";


export function* handleSendForms() {
	while (true) {
		const action = yield take(`${sendForms}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'contact/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			yield put(failSendForms({system_mail:payload.sysytem_mail}));
			continue;
		}
		yield put(successSendForms(Object.assign({}, payload, {})));
	}
}


// WEBPACK FOOTER //
// ./src/sagas/forms.js